module.exports = __webpack_public_path__ + "img/fig28.698c8dc9.jpg";